var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b5b5b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "log-in") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,0A28,28,0,1,0,56,28,28,28,0,0,0,28,0Zm0,54A26,26,0,1,1,54,28,26,26,0,0,1,28,54Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.45,33.47a.82.82,0,0,1-.58-.24l-5.59-5.59a.84.84,0,0,1-.18-.27.82.82,0,0,1,.18-.9l5.59-5.59A.82.82,0,1,1,31,22l-4.18,4.18h15a.82.82,0,1,1,0,1.65h-15L31,32.06a.82.82,0,0,1-.58,1.41Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.42,43.75a.84.84,0,0,1-.25,0h0L14.9,39.86h0l-.06,0-.17-.11-.07-.07a.79.79,0,0,1-.11-.17l0-.08a.81.81,0,0,1-.06-.29V13.82a.81.81,0,0,1,.06-.29l0-.05a.84.84,0,0,1,.15-.22h0l0,0,.07-.07,0,0,0,0L15,13l.11,0H33.84a.82.82,0,0,1,.82.82v9.33a.82.82,0,0,1-1.65,0V14.65H18.58l4.12,2.24a.82.82,0,0,1,.55.78V38.26H33V29.75a.82.82,0,0,1,1.65,0v9.33a.82.82,0,0,1-.82.82H23.25v3a.82.82,0,0,1-.82.82Zm-.82-2V18.23L16,15V38.52Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn);
export default __webpack_public_path__ + "static/media/log-in.d738775face1fa76bd7d733ce28926bc.svg";
export { ForwardRef as ReactComponent };